import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from 'services/api';
import type { Tenant } from './useTenants';
import { TENANTS_QUERY_KEY } from './useTenants';

export const useDeleteTenant = () => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tenant: Tenant) => {
      await api.delete(`/tenants/${tenant.id}`);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TENANTS_QUERY_KEY });
    },
  });
};
